/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

! function () {
    "use strict";

    angular.module('webReader').service('NetworkService', constructor);

    function constructor(HashService, $cookieStore, $http, $q, API_DEFAULT_URL, TRANSLATION_KEY) {
        let self = this,
            $cookies = $cookieStore,
            requestHeader = { headers: {} },
            targetTranslationLanguage,
            isTokenUpdating = false;


        angular.extend(self, {
            updateHeader: function () {
                requestHeader = self.buildRequestHeader();
            },

            buildRequestHeader: function (renewToken) {
                return renewToken ? {
                    headers: {
                        'Authorization': 'Bearer ' + $cookies.get('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                } : {
                        headers: {
                            'Authorization': 'Bearer ' + $cookies.get('accessToken'),
                            'Accept': '*/*'
                        }
                    };
            },

            getDocumentInfo: function (documentPath) {
                var methodName = 'documentInformation',
                    docPath = encodeURIComponent(documentPath),
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + 'reader/documentInformation' + documentPath;

                return $http
                    .get(url, requestHeader)
                    .then(self.success('JSON'))
                    .catch(response => {
                            // location.reload();
                            return self.error(response, self.getDocumentInfo.bind(null, documentPath))
                        })
            },

            getDocumentMeta: function (documentPath) {
                var methodName = 'fileops/info',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + documentPath + '?include_metadata=true';
                return $http.get(url, requestHeader)
                    .then(function (res) {
                        return res;
                    })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.getDocumentMeta.bind(null, documentPath)))
            },

            getNotes: function (documentPath) {
                var methodName = 'notes',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + '?path=' + encodeURI(documentPath);

                return $http.get(url, requestHeader)
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.getNotes.bind(null, documentPath)));
            },

            getNote: function (documentPath, uuid) {
                var methodName = 'notes/',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + uuid + '?path=' + encodeURI(documentPath);
                return $http.get(url, requestHeader).then(function (resp) {
                    return resp;
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.getNote.bind(null, documentPath, uuid)));
            },

            addNote: function (documentPath, selection, noteText, selectionOffsetObject, color) {
                var methodName = 'notes',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString();

                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "mark": {
                            "anchor": selectionOffsetObject.start_pointer,
                            "updated": moment
                        },
                        "type": {
                            "value": "note",
                            "updated": moment
                        },
                        "color": {
                            "value": color,
                            "updated": moment
                        },
                        "note": {
                            "text": noteText,
                            "format": "markdown",
                            "updated": moment
                        },
                        "quotation": {
                            "begin": selectionOffsetObject.start_pointer,
                            "end": selectionOffsetObject.end_pointer,
                            "text": selectionOffsetObject.selectionText.substr(0, 200),
                            "updated": moment
                        }
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.addNote.bind(null, documentPath, selection, noteText, selectionOffsetObject, color)));
            },

            updateNoteText: function (documentPath, noteObject) {
                var methodName = 'notes/' + noteObject.uuid,
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString(),
                    noteText = !!noteObject.note ? noteObject.note.text || '' : '';


                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "note": {
                            "text": noteObject.note.text,
                            "format": "markdown",
                            "updated": moment
                        },
                        "color": {
                            "value": noteObject.color.value,
                            "updated": moment
                        },
                        // "userNote": {
                        //     "value": {
                        //         "text": noteObject.userNote.value.text,
                        //         "format": "markdown"
                        //     },
                        //     "updated": moment
                        // },
                        // "subtype": {
                        //     "value": noteObject.subtype.value,
                        //     "updated": moment
                        // },
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.updateNoteText.bind(null, documentPath, noteObject)));
            },

            removeNote: function (documentPath, uuid) {
                var methodName = 'notes/',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + uuid + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString();

                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "type": {
                            "value": "deleted",
                            "updated": moment
                        }
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.removeNote.bind(null, documentPath, uuid)));
            },

            getBookmarks: function (documentPath) {
                return self.getNotes(documentPath);
            },

            getBookmark: function (documentPath, uuid) {
                // console.log(self.getNote(documentPath, uuid), 'promise?');
                return self.getNote(documentPath, uuid);
            },

            addBookmark: function (documentPath, chapterOffsetObject, page) {
                // console.log(documentPath, chapterOffsetObject, page);
                var methodName = 'notes',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString();

                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "type": {
                            "value": "bookmark",
                            "updated": moment
                        },
                        "note": {
                            "text": angular.element(chapterOffsetObject.element).text().substring(0, 80) + '...',
                            "format": "markdown",
                            "updated": moment
                        },
                        "anchor": {
                            "anchor": chapterOffsetObject.pointer,
                            "updated": moment
                        },
                        "bookmarkPage": page,
                        "quotation": {
                            "begin": chapterOffsetObject.pointer,
                            "end": chapterOffsetObject.pointer_pb,
                            "text": angular.element(chapterOffsetObject.element).text().substring(0, 80) + '...',
                            "updated": moment
                        },
                        "mark": {
                            "anchor": chapterOffsetObject.pointer,
                            "updated": moment
                        }
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.addBookmark.bind(null, documentPath, chapterOffsetObject, page)));
            },

            removeBookmark: function (documentPath, uuid) {
                return self.removeNote(documentPath, uuid);
            },
            removeHighlight: function (documentPath, uuid) {
                var methodName = 'notes/',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + uuid + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString();
                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "type": {
                            "value": "deleted",
                            "updated": moment
                        }
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        (response) =>
                    self.error(response, self.addHighlight.bind(null, documentPath, selectionOffsetObject))
                );
            },
            getHighlights: function (documentPath) {
                return self.getNotes(documentPath);
            },

            getHighlight: function (documentPath, uuid) {
                return self.getNote(documentPath, uuid);
            },

            addHighlight: function (documentPath, selectionOffsetObject) {
                var methodName = 'notes',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + '?path=' + encodeURI(documentPath),
                    moment = (new Date()).toUTCString();

                return $http({
                    method: 'POST',
                    url: url,
                    headers: requestHeader.headers,
                    data: {
                        "mark": {
                            "anchor": selectionOffsetObject.start_pointer,
                            "updated": moment
                        },
                        "type": {
                            "value": "highlight",
                            "updated": moment
                        },
                        "color": {
                            "value": selectionOffsetObject.className,
                            "updated": moment
                        },
                        "quotation": {
                            "begin": selectionOffsetObject.start_pointer,
                            "end": selectionOffsetObject.end_pointer,
                            "text": selectionOffsetObject.selectionText.substr(0, 200),
                            "updated": moment
                        }
                        // "subtype": {
                        //     "value": '',
                        //     "updated": moment
                        // },
                        // "selectionRange": {
                        //     "value": selectionOffsetObject.start_pointer,
                        //     "updated": moment
                        // },
                        // "color": {
                        //     "value": selectionOffsetObject.className || '',
                        //     "updated": moment
                        // },
                        // "userNote": {
                        //     "value": {
                        //         "text": selectionOffsetObject.selectionText.substr(0, 200),
                        //         "format": "markdown"
                        //     },
                        //     "updated": moment
                        // },
                        // "excerpt": {
                        //     "location": {
                        //         "value": "pbl:" + selectionOffsetObject.pointer_pb.url + '?offs=' + selectionOffsetObject.pointer_pb.offsetChars +
                        //         '&pixelsTop=' + selectionOffsetObject.pointer_pb.pOffset.toFixed(0),
                        //         "updated": moment
                        //     },
                        //     "selectionRange": {
                        //         "value": selectionOffsetObject.end_pointer,
                        //         "updated": moment
                        //     },
                        //     "selectionText": {
                        //         "value": selectionOffsetObject.selectionText.substr(0, 200),
                        //         "updated": moment
                        //     }
                        // }
                    }
                })
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.addHighlight.bind(null, documentPath, selectionOffsetObject)));
            },


            updateToken: function () {
                if (isTokenUpdating) return Promise.resolve();
                isTokenUpdating = true;
                let methodName = 'auth/renew-token',
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName;

                return $http({
                    method: 'POST',
                    url: url,
                    headers: self.buildRequestHeader(true).headers,
                    data: "grant_type=refresh_token&refresh_token=" + encodeURI($cookies.get('refreshToken'))
                })
                    .then(self.success('JSON'))
                    .then(data => {
                        $cookies.put('accessToken', data.access_token);
                        $cookies.put('refreshToken', data.refresh_token);
                        self.updateHeader(true);
                        isTokenUpdating = false;
                        // console.log('accessToken', $cookies.get('accessToken'));
                        // console.log('refreshToken', $cookies.get('refreshToken'));
                        // location.reload();
                    })
                    .catch(response =>
                        window.location.href =
                            '/browser/#access_token='
                            + $cookies.get('accessToken')
                            + '&refresh_token='
                            + $cookies.get('refreshToken'));
            },

            updateBookOffset: function (newChapterOffsetObject, sync) {
                //todo: here
                // debugger
                console.log('updateBookOffset');
                var methodName = 'fileops/info',
                    documentPath = $cookies.get('path'),
                    url = (HashService.getHashParameters()['api_url'] || API_DEFAULT_URL) + methodName + documentPath + '?path=' + documentPath;
                var data = {
                    //"favorite": newChapterOffsetObject.favorite,
                    //"collections": [],
                    "position": {
                        "pointer_pb": newChapterOffsetObject.pointer_pb,
                        "percent": parseInt(newChapterOffsetObject.percent),
                        "updated": (new Date()).toUTCString(),
                        "pointer": newChapterOffsetObject.pointer
                    }
                };
                //there is no way to go on this leg (every updateBookOffset call make 'sync' falsey...
                if (!!sync) {
                    var request = new XMLHttpRequest();
                    request.open('POST', url, false); // `false` makes the request synchronous
                    request.setRequestHeader('Authorization', 'Bearer ' + $cookies.get('accessToken'));
                    request.send(JSON.stringify(data));

                    return {
                        status: request.status,
                        data: request.responseText
                    }
                } else {
                    return $http({
                        method: 'POST',
                        url: url,
                        headers: requestHeader.headers,
                        data: data
                    })
                        .then(self.success('JSON'))
                        .catch(response =>
                            self.error(response, self.updateBookOffset.bind(null, newChapterOffsetObject, sync)));
                }
            },

            getChapterContent: function (chapterPath) {
                return $http
                    .get(chapterPath)
                    .then(self.success('XML'))
                    .catch(response =>
                        self.error(response, self.getChapterContent.bind(null, chapterPath)));
            },

            getChapterPDFContent: function (chapterPath) {
                return $http
                    .get(chapterPath)
                    .then(self.success('PNG'))
                    .catch(response =>
                        self.error(response, self.getChapterPDFContent.bind(null, chapterPath)));
            },

            getStylesheet: function (StylePath) {
                return $http
                    .get(StylePath)
                    .then(self.success('CSS'))
                    .catch(response =>
                        self.error(response, self.getStylesheet.bind(null, StylePath)));
            },

            getLocalizationFile: function (localization) {
                var filename = 'reader-' + localization + '.json';
                var url = 'localization/' + filename.toLowerCase();
                // console.log(url);
                return $http
                    .get(url, requestHeader)
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.getLocalizationFile.bind(null, localization)));
            },

            getTranslation: function (sourceString) {

                //https://www.googleapis.com/language/translate/v2?key=AIzaSyD_g_bxXRopTiuB9LBr8rL1iLJ5H8fHL6g&source=en&target=de&q=Hello%20world
                var url = 'https://www.googleapis.com/language/translate/v2?key=' + TRANSLATION_KEY + '&target=' + targetTranslationLanguage + '&q=' + encodeURI(sourceString);

                return $http
                    .get(url)
                    .then(self.success('JSON'))
                    .catch(response =>
                        self.error(response, self.getTranslation.bind(null, sourceString)));
            },

            setTargetLanguage: function (targetLanguage) {
                targetTranslationLanguage = targetLanguage;
            },

            success: function (responseType) {
                return {
                    'JSON': function (response) {
                        if (self.withError(response)) {
                            return $q.reject(response);
                        }

                        return self.processData(response);
                    },
                    'XML': function (response) {
                        if (self.withError(response)) {
                            return $q.reject(response);
                        }

                        return self.processXMLData(response);
                    },
                    'CSS': function (response) {
                        if (self.withError(response)) {
                            return $q.reject(response);
                        }

                        return self.processCSSData(response);
                    },
                    'PNG': function (response) {
                        if (self.withError(response)) {
                            return $q.reject(response);
                        }

                        return self.processPNGData(response);
                    }
                }[responseType];
            },

            error(response, func) {
                // console.log("reponse status is" + response.status);
                if (response.status === 401 || response.status === 403) {
                    return self
                        .updateToken()
                        .then(() => func())
                        .catch(response => {
                            console.log('error catch response - ', response);
                        });
                }
                //Safari workaround
                if (!response.statusText) {
                    return $http.get(response.config.url + '?no_redirect=1').then(function (data) {
                        return $http.get(data.data.redirect_url).then(self.success('XML')).catch(self.error);
                    }).catch(self.error);
                }
            },

            withError: function (response) {
                return response.status < 200 || response.status > 299;
            },

            processData: function (response) {
                // console.log(response, 'process data')
                return (_.isString(response.data) ? (!!response.data ? JSON.parse(response.data) : {}) : response.data) || {
                    message: 'Fatal error. Unhandled server exception',
                    reason: 'Retrieve invalid data'
                };
            },

            processXMLData: function (response) {
                var parser = new DOMParser();
                return (_.isString(response.data) ? parser
                    .parseFromString(response.data.replace(/<body[^>]{0,}>/ig, '<body><div>')
                        .replace('</body>', '</div></body>'), "text/xml") : response.data) || {
                        message: 'Fatal error. Unhandled server exception',
                        reason: 'Retrieve invalid data'
                    };
            },

            processCSSData: function (response) {
                return _.isString(response.data) ? response.data : {
                    message: 'Fatal error. Unhandled server exception',
                    reason: 'Retrieve invalid data'
                };
            },

            processPNGData: function (response) {
                return response.config.url;
            }
        });
    }
    constructor.$inject = ["HashService", "$cookieStore", "$http", "$q", "API_DEFAULT_URL", "TRANSLATION_KEY"];
} ();